import { IError, IQueryHookOptions } from '@comptia-sso/core';
import { UseMutateAsyncFunction, useMutation } from 'react-query';

// Services.
import { resendConsent } from 'services';

import { IResendConsentRequest, IResendConsentResponse } from 'types';

type ResendConsentFunction = UseMutateAsyncFunction<
  IResendConsentResponse,
  IError,
  IResendConsentRequest
>;

type UseResendConsent = [ResendConsentFunction, IQueryHookOptions];

export const useResendConsent = (id = ''): UseResendConsent => {
  const { error, isError, isLoading, mutateAsync } = useMutation<
    IResendConsentResponse,
    IError,
    IResendConsentRequest
  >((values: IResendConsentRequest) => resendConsent(id, values));

  return [mutateAsync, { error, isError, isLoading }];
};
